// Window events global search dispatches for results that run a header action (dialog, help link, tour) instead of navigating.
// Kept dependency-free so header sections can listen without importing the search data.

/** Profile section opens its About dialog. */
export const OPEN_ABOUT_DIALOG_FROM_SEARCH = 'OPEN_ABOUT_DIALOG_FROM_SEARCH';

/** Support (help) section opens its FAQ dialog. */
export const OPEN_FAQ_DIALOG_FROM_SEARCH = 'OPEN_FAQ_DIALOG_FROM_SEARCH';

/** Support (help) section opens the Insight Knowledge Base in a new tab. */
export const OPEN_KNOWLEDGE_BASE_FROM_SEARCH = 'OPEN_KNOWLEDGE_BASE_FROM_SEARCH';

/** Support (help) section starts the guided tour. */
export const START_GUIDED_TOUR_FROM_SEARCH = 'START_GUIDED_TOUR_FROM_SEARCH';
